import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info', duration = 3500) => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
  }, []);

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <div className="toast-container">
        {toasts.map(toast => (
          <div key={toast.id} className={`toast ${toast.type}`}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              {toast.type === 'success' && <path d="M2 7l4 4 6-6" stroke="var(--green)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>}
              {toast.type === 'error' && <path d="M3 3l8 8M11 3l-8 8" stroke="var(--red)" strokeWidth="1.5" strokeLinecap="round"/>}
              {toast.type === 'info' && <><circle cx="7" cy="7" r="6" stroke="var(--accent)" strokeWidth="1.2"/><path d="M7 6.5v4" stroke="var(--accent)" strokeWidth="1.4" strokeLinecap="round"/><circle cx="7" cy="4.5" r="0.7" fill="var(--accent)"/></>}
            </svg>
            <span>{toast.message}</span>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
